/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface CalculationErrorInfo
 */
export interface CalculationErrorInfo {
  /**
   *
   * @type {string}
   * @memberof CalculationErrorInfo
   */
  reason?: string | null;
  /**
   *
   * @type {string}
   * @memberof CalculationErrorInfo
   */
  entityType?: CalculationErrorInfoEntityTypeEnum | null;
  /**
   *
   * @type {string}
   * @memberof CalculationErrorInfo
   */
  entityUuid?: string | null;
  /**
   *
   * @type {string}
   * @memberof CalculationErrorInfo
   */
  entityName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CalculationErrorInfo
   */
  entityTypeName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CalculationErrorInfo
   */
  tabKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof CalculationErrorInfo
   */
  fieldName?: string | null;
}

/**
 * @export
 */
export const CalculationErrorInfoEntityTypeEnum = {
  Model: 'model',
  Element: 'element',
  Sample: 'sample',
  Blend: 'blend'
} as const;
export type CalculationErrorInfoEntityTypeEnum =
  (typeof CalculationErrorInfoEntityTypeEnum)[keyof typeof CalculationErrorInfoEntityTypeEnum];

/**
 * Check if a given object implements the CalculationErrorInfo interface.
 */
export function instanceOfCalculationErrorInfo(value: object): value is CalculationErrorInfo {
  return true;
}

export function CalculationErrorInfoFromJSON(json: any): CalculationErrorInfo {
  return CalculationErrorInfoFromJSONTyped(json, false);
}

export function CalculationErrorInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculationErrorInfo {
  if (json == null) {
    return json;
  }
  return {
    reason: json['reason'] == null ? undefined : json['reason'],
    entityType: json['entity_type'] == null ? undefined : json['entity_type'],
    entityUuid: json['entity_uuid'] == null ? undefined : json['entity_uuid'],
    entityName: json['entity_name'] == null ? undefined : json['entity_name'],
    entityTypeName: json['entity_type_name'] == null ? undefined : json['entity_type_name'],
    tabKey: json['tab_key'] == null ? undefined : json['tab_key'],
    fieldName: json['field_name'] == null ? undefined : json['field_name']
  };
}

export function CalculationErrorInfoToJSON(value?: CalculationErrorInfo | null): any {
  if (value == null) {
    return value;
  }
  return {
    reason: value['reason'],
    entity_type: value['entityType'],
    entity_uuid: value['entityUuid'],
    entity_name: value['entityName'],
    entity_type_name: value['entityTypeName'],
    tab_key: value['tabKey'],
    field_name: value['fieldName']
  };
}
